import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import Report016Container from 'app/containers/Report/Report016'

const Report016PageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.report_16)}</PageTitle>
      <Report016Container />
    </>
  )
}
const Report016Page = memo(Report016PageCpn, isEqual)

export default Report016Page
